<template>
  <div style="padding: 10px">
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-date"
      @click="openEditSpeakerTaskDialog(true)"
      >创建喇叭任务</el-button
    >

    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-s-promotion"
      @click="openSendSpeakerMessageDialog()"
      >发送喇叭消息</el-button
    >

    <el-table :data="speakerTaskList" border size="small" style="width: 850px">
    </el-table>

    <!-- “编辑喇叭任务”对话框 -->
    <EditSpeakerTaskDialog
      v-if="shouldEditSpeakerTaskDialogVisible"
      @close="onEditSpeakerTaskDialogClosed()"
      :value="valueForEditSpeakerTaskDialog"
    ></EditSpeakerTaskDialog>

    <!-- “发送喇叭消息”对话框 -->
    <SendSpeakerMessageDialog
      v-if="shouldSendSpeakerMessageDialogVisible"
      @close="onSendSpeakerMessageDialogClosed()"
    ></SendSpeakerMessageDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";

import EditSpeakerTaskDialog from "./EditSpeakerTaskDialog";
import SendSpeakerMessageDialog from "./SendSpeakerMessageDialog";

export default {
  data() {
    return {
      shouldEditSpeakerTaskDialogVisible: false, // “编辑喇叭任务”对话框是否应该显示出来
      valueForEditSpeakerTaskDialog: null, // 要传递给“编辑喇叭任务”对话框的数据
      shouldSendSpeakerMessageDialogVisible: false, // “发送喇叭消息”对话框是否应该显示出来
      speakerTaskList: [], // 喇叭任务集合
    };
  },

  created() {
    // 拉取喇叭任务集合
    this.loadSpeakerTaskList();
  },

  components: {
    EditSpeakerTaskDialog,
    SendSpeakerMessageDialog,
  },

  methods: {
    /**
     * 拉取喇叭任务集合
     */
    async loadSpeakerTaskList() {},

    /**
     * 删除一个喇叭任务
     * @param {*} id
     */
    async deleteSpeakerTask(id) {},

    /**
     * 打开“编辑喇叭任务”对话框
     */
    async openEditSpeakerTaskDialog(isCreate, oldData) {
      this.shouldEditSpeakerTaskDialogVisible = true;
      this.valueForEditSpeakerTaskDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 打开“发送喇叭消息”对话框
     */
    async openSendSpeakerMessageDialog() {
      this.shouldSendSpeakerMessageDialogVisible = true;
    },

    /**
     * “编辑喇叭任务”对话框关闭了
     */
    async onEditSpeakerTaskDialogClosed() {
      this.shouldEditSpeakerTaskDialogVisible = false;

      // 重新拉取喇叭任务集合
      return this.loadSpeakerTaskList();
    },

    /**
     * “发送喇叭消息”对话框关闭了
     */
    async onSendSpeakerMessageDialogClosed() {
      this.shouldSendSpeakerMessageDialogVisible = false;
    },
  },
};
</script>
